module.exports = __webpack_public_path__ + "static/freescantrio1line-fa6065ebd56f1615ee0bd0abadcf3a34.jpg";